<script>
    import { navigate } from "svelte-routing";
    import { apiResults } from './store';
    import MediaQuery from "./MediaQuery.svelte";
    import Loader from './Loader.svelte';
    import {selectTextOnFocus} from './inputDirectives.js';
    
    export let pageUrl = '';
    export let loading = false;

    let imgWrapperWidth;
    let imgWrapperHeight;
    let menuHeight = 90;
    let imgWidth = 270;
    let imgPadding = 50;
    let promptWidth;
    let paddingBottomS = 38;
    let paddingBottomL;

	function checkPage() {
		loading = true;
        getResult(pageUrl)
            .then( result => {
                console.log(result);
                loading = false;
                apiResults.update(n => {
                     return result;
                    });
                navigate("/results", { replace: true });
            });

        // temp for building results page
        // navigate('/results', { replace: true });
		
	}

  function getPaddingStyleForContentBox() {
    return `padding-left: ${imgWrapperWidth - imgWidth + imgPadding}px; padding-right: ${imgWrapperWidth - imgWidth}px;`;
  }

	async function getResult() {

        let response = await fetch(`/api/site?url=${pageUrl}`);
        let text = await response.text();
		let data = text;
        return data;
    }
</script>

{#if loading}
  <Loader currentUrl='{pageUrl}'/>
{/if}

<!-- <div>
  <p>promptWidth: {promptWidth} imgWrapperHeight: {imgWrapperHeight}</p>
  <p>imgWrapperWidth: {imgWrapperWidth} imgWidth: {imgWidth}</p>
</div> -->
<div class="main-prompt" bind:clientWidth={promptWidth}>
  <div class="main-img-wrapper" bind:clientWidth={imgWrapperWidth} bind:clientHeight={imgWrapperHeight}>
    <MediaQuery query="(min-width: 1024px)" let:matches>
      {#if matches}
      <div class="main-img-bg" style="right: 5px; bottom: 50px; padding-bottom: 30px; clip-path: polygon(0 0, {promptWidth/3}px 0, 100% {imgWrapperHeight - 40}px, {imgWrapperWidth - 30}px 100%, 0 {imgWrapperHeight -180}px)"></div>
      {/if}
    </MediaQuery>

    <MediaQuery query="(max-width: 1023px)" let:matches>
      {#if matches}
      <div class="main-img-bg" style="bottom: 50px; padding-bottom: 30px; clip-path: polygon(0 0, {imgWrapperWidth/3 + (imgWrapperWidth-imgWidth)/2 + 15}px 0, 100% {imgWrapperHeight - menuHeight + 50}px, {imgWrapperWidth - 30}px  {imgWrapperHeight + 30}px, 0 {imgWrapperHeight/2}px); right: {(imgWrapperWidth-imgWidth)/2 + 5}px;"></div>
      {/if}
    </MediaQuery>
    
    <div class="main-img__inner-wrapper">
      <img class="main-img" src="./img/web-energy.png" alt="Comiczeichnung einer Person, welche ein aufgeklapptes Laptop hält. Vom Monitor geht ein Lichstrahl aus, dieser strahlt die Begriffe CO2, Energie und Daten an." />
    </div>
  </div>
  
  <MediaQuery query="(min-width: 1024px)" let:matches>
    {#if matches}
    <div class="main-prompt-text" style="margin-left: {imgWrapperWidth}px; height: {imgWrapperHeight}px; margin-right: {imgWrapperWidth -imgWidth}px;">
       <h1>Wie nachhaltig ist Ihre Website?</h1>

      <p>Finden Sie heraus, wie ressourcenschonend Ihre Webseite ist und was Sie tun können, um Ihre digitale Nachhaltigkeit zu verbessern.</p>
    </div>
    {/if}
  </MediaQuery>

  <MediaQuery query="(max-width: 1023px)" let:matches>
    {#if matches}
		<div class="main-prompt-text" style="margin-top: {imgWrapperHeight}px;">
      <h1>Wie nachhaltig ist Ihre Website?</h1>

      <p>Finden Sie heraus, wie ressourcenschonend Ihre Webseite ist und was Sie tun können, um Ihre digitale Nachhaltigkeit zu verbessern.</p>
    </div>
    {/if}
  </MediaQuery>
</div>

<MediaQuery query="(min-width: 1024px)" let:matches>
  {#if matches}
    <div class="content-box main-url-box alt-bg" style="{getPaddingStyleForContentBox()}">
      <div class="main-url__input">
        <label for="websiteUrl">URL</label>
        <input type="text" id="websiteUrl" use:selectTextOnFocus bind:value={pageUrl} on:keyup={e=>e.key==='Enter' && checkPage()}>
      </div>
      <button on:click={checkPage} class="main-url__btn">Seite testen</button>
    </div>

    <div class="content-box" style="{getPaddingStyleForContentBox()}">
      <div>
        <h2>Internetnutzung verschlingt viel Energie: Im Jahr circa 416,2TWh. </h2>
        <p>Von den Servern auf denen unsere Daten liegen, über die Netzwerke welche diese transportieren bis zu den Geräten die wir zuhause benutzen: Alle verbrauchen Strom und erzeugen somit Emissionen.</p>
      </div>
    </div>
  {/if}
</MediaQuery>

<MediaQuery query="(max-width: 1023px)" let:matches>
    {#if matches}
    <div class="content-box main-url-box alt-bg">
      <div class="main-url__input">
        <label for="websiteUrl">URL</label>
        <input type="text" id="websiteUrl" use:selectTextOnFocus bind:value={pageUrl} on:keyup={e=>e.key==='Enter' && checkPage()}>
      </div>
      <button on:click={checkPage} class="main-url__btn">Seite testen</button>
    </div>

    <div class="content-box">
      <div>
        <h2>Internetnutzung verschlingt viel Energie: Im Jahr circa 416,2TWh. </h2>
        <p>Von den Servern auf denen unsere Daten liegen, über die Netzwerke welche diese transportieren bis zu den Geräten die wir zuhause benutzen: Alle verbrauchen Strom und erzeugen somit Emissionen.</p>
      </div>
    </div>
    {/if}
  </MediaQuery>

  <MediaQuery query="(min-width: 1024px)" let:matches>
    {#if matches}
      <div class="content-box alt-bg" style="{getPaddingStyleForContentBox()}">
        <div><img class="facts-img" src="./img/www.png" alt="Eine Weltkugel mit der Aufschrift WWW und einem Stecker, welcher zu dem Umriss von Häusern führt."></div>
        <div class="fact-bubble normal-bg" style="margin-left: 2em;">
          <p>Das Internet verbraucht im Jahr <strong class="highlighted-text">DREIMAL</strong> mehr Strom als alle deutschen Haushalte zusammen</p>
        </div>
      </div>

      <div class="content-box alt-bg" style="{getPaddingStyleForContentBox()} padding-top:0;">
        <div class="fact-bubble normal-bg" style="margin-right: 2em;">
          <p><strong class="highlighted-text">Einhundert Webseitenbesuche</strong> erzeugen dieselben CO2 Emissionen wie <strong class="highlighted-text">1 km</strong> Auto fahren</p>
        </div>
        <div><img class="facts-img" src="./img/1km.png" alt="Eine Webseite auf die geklickt wird aus der ein Pfeil mit CO2 kommt, welcher auf ein fahrendes Auto zeigt."></div>
      </div>
    {/if}
  </MediaQuery>

  <MediaQuery query="(min-width: 768px) and (max-width: 1023px)" let:matches>
    {#if matches}
      <div class="content-box alt-bg">
        <div><img class="facts-img" src="./img/www.png" alt="Eine Weltkugel mit der Aufschrift WWW und einem Stecker, welcher zu dem Umriss von Häusern führt."></div>
        <div class="fact-bubble normal-bg" style="margin-left: 2em;">
          <p>Das Internet verbraucht im Jahr <strong class="highlighted-text">DREIMAL</strong> mehr Strom als alle deutschen Haushalte zusammen</p>
        </div>
      </div>

      <div class="content-box alt-bg" style="padding-top:0;">
        <div class="fact-bubble normal-bg" style="margin-right: 2em;">
          <p><strong class="highlighted-text">Einhundert Webseitenbesuche</strong> erzeugen dieselben CO2 Emissionen wie <strong class="highlighted-text">1 km</strong> Auto fahren</p>
        </div>
        <div><img class="facts-img" src="./img/1km.png" alt="Eine Webseite auf die geklickt wird aus der ein Pfeil mit CO2 kommt, welcher auf ein fahrendes Auto zeigt."></div>
      </div>
    {/if}
  </MediaQuery>

  <MediaQuery query="(max-width: 767px)" let:matches>
    {#if matches}
      <div class="content-box alt-bg">
        <img class="facts-img" src="./img/www.png" alt="Eine Weltkugel mit der Aufschrift WWW und einem Stecker, welcher zu dem Umriss von Häusern führt.">
        <div class="fact-bubble normal-bg" style="margin-top: 1em;">
          <p>Das Internet verbraucht im Jahr <strong class="highlighted-text">DREIMAL</strong> mehr Strom als alle deutschen Haushalte zusammen</p>
        </div>
      </div>

      <div class="content-box alt-bg">
        <img class="facts-img" src="./img/co2.png" alt="Eine Laptop aus dem eine Wolke CO2 kommt.">
        <div class="fact-bubble normal-bg" style="margin-top: 1em;">
          <p><strong class="highlighted-text">Einhundert Webseitenbesuche</strong> erzeugen dieselben CO2 Emissionen wie <strong class="highlighted-text">1 km</strong> Auto fahren</p>
      </div>
      </div>
    {/if}
  </MediaQuery>

<style>
  h1 {
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 34px;
      text-align: left;

      color: var(--highlight-text-color);
    }

.main-prompt {
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  font-size: 16px;
  background-color: var(--ci-red);
  color: white;

  padding-bottom: 2em;
}

.main-img-wrapper {
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
}

.main-img__inner-wrapper{
  height: 296px;
  padding-top: 2em;
  z-index: 10;
}

.main-img{
  width: 270px;
}

.main-img-bg{
  background: var(--white) !important;
  opacity: 0.8;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  right: 20px;
  bottom: 80px; /* same as menu-height */
}

.main-prompt-text{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-left: 2em;
}

.main-prompt-text h1 {
  color: var(--white);
  font-size: 36px;
  padding-top: 0.8em;
}

.main-prompt-text p{
  margin-block-end: 0;
  padding-right: 1em;
}

.main-url-box{
  align-items: flex-end;
}

@media only screen and (min-width: 768px) {
  .main-url__input{
    flex-grow: 1;
  }
}

.main-url__input{
  width: 100%;
}

.main-url__input input{
  width: 100%;
}

.main-url__btn{
  margin-left: 1em;
  width: 100%;
}

@media only screen and (min-width: 768px) {
  .main-url__btn{
    width: fit-content;
    white-space: nowrap;
  }
}

.fact-bubble {
  border-radius: 1em;
  padding: 0.5em 2em;
}

.facts-img{
  width: 100%;
}

@media only screen and (min-width: 768px) {
  .facts-img {
    width: auto;
  }
}

input {
  padding: 0.5em;
  border: 2px solid #000000;
	box-sizing: border-box;
	border-radius: 8px;
}

label{
  font-weight: 600;
}

@media only screen and (min-width: 1024px) {
  .main-img-wrapper {
    width: 40%;
  }


  .main-prompt {
    flex-direction: row;
  }

  .main-img-wrapper {
    justify-content: flex-end;
  }

  .main-prompt-text h1 {
    font-size: 48px;
    line-height: 57px;
  }
}
</style>